// Only these hostnames use the live API. Every other hostname — localhost,
// UAT, staging, preview domains — uses the UAT API, so live data is never
// touched by accident.
export const LIVE_HOSTS = ['infinity88.ink'];

const LIVE_API_URL = 'https://api.infinity88.ink/';
const UAT_API_URL = 'https://cashapi.greatwallsolution.com/';

function resolveApiUrl() {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    return LIVE_HOSTS.includes(hostname) ? LIVE_API_URL : UAT_API_URL;
}

const config = {
    url: resolveApiUrl()
};

export default config;
